var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 12.7417V4.75835C1.66675 3.65002 2.30841 3.38335 3.09175 4.16668L5.25008 6.32502C5.57508 6.65002 6.10841 6.65002 6.42508 6.32502L9.40842 3.33335C9.73342 3.00835 10.2667 3.00835 10.5834 3.33335L13.5751 6.32502C13.9001 6.65002 14.4334 6.65002 14.7501 6.32502L16.9084 4.16668C17.6917 3.38335 18.3334 3.65002 18.3334 4.75835V12.75C18.3334 15.25 16.6667 16.9167 14.1667 16.9167H5.83341C3.53341 16.9083 1.66675 15.0417 1.66675 12.7417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.e8fd3c2801bbd96ea1694a6e01ab5f15.svg";
export { ForwardRef as ReactComponent };